import {I18n} from '@aws-amplify/core';
import {SimplePageHeader} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";

const useTools = () => {
    const {allowedActions} = useVerifiedPermissions();

    console.log('Provider Mappings - Allowed Actions:', allowedActions);
    console.log('Looking for CreateProviderMapping:', rbacActions.CreateProviderMapping);
    console.log('Looking for DeleteProviderMapping:', rbacActions.DeleteProviderMapping);

    const tools = [<ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes(rbacActions.DeleteProviderMapping)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }
    if (allowedActions.includes(rbacActions.CreateProviderMapping)) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Provider Mappings')}
            tools={useTools()}
        />
    );
};